import { Drawer, DrawerProps } from "antd-v5";
import React from "react";

import ACButton from "ac-components/ac-button/ACButton";
import CloseIcon from "ac-components/ac-icons/CloseIcon";

import "./ACDrawer.less";

type ACDrawerProps = Omit<DrawerProps, "prefixCls" | "getContainer"> & {};

export default function ACDrawer({
  closable,
  title,
  ...drawerProps
}: ACDrawerProps) {
  return (
    <Drawer
      title={
        closable ? (
          <div className="d-flex justify-content-between align-items-center">
            <div className="flex-1 text-ellipsis">{title}</div>
            <ACButton type="outline" iconOnly onClick={drawerProps.onClose}>
              <CloseIcon />
            </ACButton>
          </div>
        ) : (
          title
        )
      }
      {...drawerProps}
      prefixCls="ac-drawer"
      closable={false}
      getContainer={() =>
        (document.getElementsByClassName(
          "app-content-wrapper",
        )[0] as HTMLElement) || document.body
      }
    />
  );
}
